import { MenuItem, Select } from "@mui/material"
import React from "react"

const ClassicSelect = React.forwardRef(
  (
    {
      handleChange,
      options = [],
      optionLabel = "name",
      optionValue = "id",
      value = "",
      placeholder = "Select an option",
    },
    ref
  ) => {
    return (
      <Select
        onChange={handleChange}
        ref={ref}
        value={value}
        displayEmpty
        fullWidth
        renderValue={(selected) => {
          // Show placeholder when no value is selected
          if (!selected) {
            return <span>{placeholder}</span>
          }
          // Otherwise, show the selected value's label
          const selectedOption = options.find(
            (option) => option[optionValue] === selected
          )
          return selectedOption ? selectedOption[optionLabel] : placeholder
        }}
      >
        {options.map((option, index) => (
          <MenuItem key={index} value={option[optionValue]}>
            {option[optionLabel]}
          </MenuItem>
        ))}
      </Select>
    )
  }
)

export default ClassicSelect
